import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { AuthProvider } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import PricingSection from './components/PricingSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import DocsPage from './components/DocsPage';
import AccessibilityWidget from './components/AccessibilityWidget';
import CookieConsentBanner from './components/CookieConsentBanner';
import AnalyticsLoader from './components/AnalyticsLoader';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import AdminPage from './pages/AdminPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import LegalPage from './pages/LegalPage';
import ContactPage from './pages/ContactPage';
import CommunityPage from './pages/CommunityPage';
import UnsubscribePage from './pages/UnsubscribePage';
import AlgorithmsPage from './pages/AlgorithmsPage';
import RiskBehaviorPage from './pages/RiskBehaviorPage';

const Home = () => {
  return (
    <div className="min-h-screen bg-[#050811]">
      <a href="#main-content" className="skip-to-content">
        Skip to main content
      </a>
      <Navbar />
      <main id="main-content" role="main">
        <HeroSection />
        <AboutSection />
        <FeaturesSection />
        <PricingSection />
        <FAQSection />
        <CTASection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/docs" element={<DocsPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/verify-email" element={<VerifyEmailPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/payment/success" element={<PaymentSuccessPage />} />
              <Route path="/unsubscribe" element={<UnsubscribePage />} />
              <Route path="/features/algorithms" element={<AlgorithmsPage />} />
              <Route path="/features/risk-behavior" element={<RiskBehaviorPage />} />

              {/* Legal / compliance — English */}
              <Route path="/terms" element={<LegalPage pageKey="terms" lang="en" />} />
              <Route path="/privacy" element={<LegalPage pageKey="privacy" lang="en" />} />
              <Route path="/refund-policy" element={<LegalPage pageKey="refund-policy" lang="en" />} />
              <Route path="/disclaimer" element={<LegalPage pageKey="disclaimer" lang="en" />} />
              <Route path="/contact" element={<ContactPage lang="en" />} />

              {/* Legal / compliance — Greek */}
              <Route path="/terms-gr" element={<LegalPage pageKey="terms" lang="el" />} />
              <Route path="/privacy-gr" element={<LegalPage pageKey="privacy" lang="el" />} />
              <Route path="/refund-policy-gr" element={<LegalPage pageKey="refund-policy" lang="el" />} />
              <Route path="/disclaimer-gr" element={<LegalPage pageKey="disclaimer" lang="el" />} />
              <Route path="/contact-gr" element={<ContactPage lang="el" />} />

              {/* Community — registration required */}
              <Route path="/community" element={<CommunityPage />} />
            </Routes>
            <AccessibilityWidget />
            <CookieConsentBanner />
            <AnalyticsLoader />
          </BrowserRouter>
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
